import { render, staticRenderFns } from "./PopupTextContentComponent.vue?vue&type=template&id=0a278db8"
import script from "./PopupTextContentComponent.vue?vue&type=script&lang=js"
export * from "./PopupTextContentComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupTextContentComponent.vue?vue&type=style&index=0&id=0a278db8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports